var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.image_url)?_c('div',{staticClass:"images-brick-item",style:({ width: _vm.width, flexGrow: _vm.flexGrow })},[_c('i',{style:({ paddingBottom: _vm.paddingBottom})}),_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.image_url),expression:"image_url"}],staticClass:"brick-item-image",attrs:{"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }